// Client-side storefront reservation cart (TNK-51). Buyer-side only — kept in
// localStorage, separate from the seller's app data.
//
// TNK-212 phase 2b — the cart now holds both single cards and locked bundles.
// Stored under a v2 key as `{ cardIds, productIds }`; `loadCart` tolerates the
// legacy v1 shape (a bare card-id array) so an in-flight cart isn't lost.

const KEY = "tcg_shop_cart_v2";
const LEGACY_KEY = "tcg_shop_cart_v1";

export interface CartPayload {
  cardIds: string[];
  productIds: string[];
}

function strArray(v: unknown): string[] {
  return Array.isArray(v)
    ? v.filter((x): x is string => typeof x === "string")
    : [];
}

export function loadCart(): CartPayload {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as unknown;
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        const obj = parsed as Record<string, unknown>;
        return {
          cardIds: strArray(obj.cardIds),
          productIds: strArray(obj.productIds),
        };
      }
    }
    // Legacy v1 — a bare array of card ids.
    const legacy = localStorage.getItem(LEGACY_KEY);
    if (legacy) {
      return {
        cardIds: strArray(JSON.parse(legacy) as unknown),
        productIds: [],
      };
    }
  } catch {
    // fall through to empty
  }
  return { cardIds: [], productIds: [] };
}

export function saveCart(payload: CartPayload): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    // ignore (private mode / quota)
  }
}
